import { openApi } from '@/api/request'
import { gioTracking } from "@/utilities/tools"

export default {
  getCruiseFilter () {
    const url = '/Rccl.OpenApi/cruise/GetCruiseFilterHomePage'
    return openApi.get(url)
  },
  setCruiseFilter (data) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseFilterV2', {
      params: {
        shipCode: data.shipCode,
        sailDate: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        cruiseSearchType: data.cruiseSearchType
      }
    })
  },
  cruiseSearch (data) {
    gioTracking('track', 'evt_Filter', {
      port:data.departureCodes || 'nil',
      departureDate:data.sailDate || 'nil',
      shipCode:data.shipCode || 'nil',
      destination:data.destinationCodes || 'nil',
      sailingNight:data.sailDays || 'nil',
      hotTags:data.tags || 'nil'
    })
    return openApi.get('/Rccl.OpenApi/Cruise/CruiseSearchApi', {
      params: {
        shipCodes: data.shipCode,
        sailDates: data.sailDate,
        sailDays: data.sailDays,
        departureCodes: data.departureCodes,
        destinationCodes: data.destinationCodes,
        tags: data.tags,
        keyword: data.keyword || '',
        cruiseSearchType: data.cruiseSearchType,
        username: data.username,
        tagSource: 'mobile',
        offset: data.offset || 0,
        limit: data.limit || 10,
        isAgency: false,
        orderBysailDate: data.orderBysailDate,
        orderByPrice: data.orderByPrice,
        orderBySailDays: data.orderBySailDays,
        orderByAmountPerNight: data.orderByAmountPerNight,
        tikTokCode: data.tikTokCode
      }
    })
  },
  getCruiseByRoute (routeCode) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetCruiseByrouteCode', {routeCode, isRow: false})
  },
  getCruiseSearchPage () {
    return openApi.post('/Rccl.OpenApi/Cruise/GetCruiseSearchView')
  },
  addWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/AddCruiseWishList', requestData)
  },
  deleteWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/DeleteCruiseWishList', requestData)
  },
  getWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/GetAll', requestData)
  },
  isInWishList (requestData) {
    return openApi.post('/Rccl.OpenApi/Cruise/IsInWishListHP', requestData)
  },
  getCruiseDetail (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetCruiseDetailHP', {
      params: requestData
    })
  },
  getStateroomCategory (requestData) {
    return openApi.post('/Rccl.OpenApi/Booking/GetAllStateroomCategoryApiHP', requestData)
  },
  getShorexByCity (requestData) {
    return openApi.get('/Rccl.OpenApi/Cruise/GetShorexIntroByCity', {
      params: requestData
    })
  },
  getCruiseReview(requestData) {
    return openApi.post('/Rccl.OpenApi/TUITravel/GetReviews', requestData)
  },
  getAllCruiseFeature() {
    return openApi.post('/Rccl.OpenApi/Cruise/GetAllCruiseFeature')
  }
}
